import { render, staticRenderFns } from "./videoManagementList.vue?vue&type=template&id=786c297a"
import script from "./videoManagementList.vue?vue&type=script&lang=js"
export * from "./videoManagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports